import React, { useEffect, useState } from "react";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import { Footer } from "../../Footer";
import Table from "react-bootstrap/Table";
import {
  Button,
  Col,
  Row,
  Modal,
  Form,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  CreatePymenentUrlFn,
  GetSubScription,
  PaymentGetById,
  RedeemPromoCode,
} from "../../redux/auth-reducer/auth-service";
import dayjs from "dayjs";
import * as icons from "react-bootstrap-icons";

export const Account_settings = () => {
  const [data, setData] = useState(false);
  const [dataItem, setDataItem] = useState([]);
  const [dataSubscription, setDataSubscription] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPromoModal, setShowPromoModal] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [validated, setValidated] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [userData, setUserData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
   const [messageSubscribe, setMessageSubscribe] = useState('')

  const sidebarfun = () => setData(!data);
  const handleOptionChange = (e) => setSelectedOption(e.target.value);

  const proceedWithPayment = async () => {
    try {
      const res = await CreatePymenentUrlFn(Number(selectedOption));
      if (res?.status === 200) {
        window.open(res.data?.data[0]?.sessionUrl, "_blank");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setShowConfirmModal(false);
    }
  };

  const handleSubmitPlayer = async () => {
    if (!selectedOption) return;

    if (
      dataSubscription?.subscriptionRemainingDays &&
      dataSubscription.subscriptionRemainingDays > 5
    ) {
      setShowConfirmModal(true);
      return;
    }
    await proceedWithPayment();
  };

  // const handleOneTab = async () => {
  //  if (!selectedOption) return;

  //   if (
  //     dataSubscription?.subscriptionRemainingDays &&
  //     dataSubscription.subscriptionRemainingDays > 5
  //   ) {
  //     setShowConfirmModal(true);
  //     return;
  //   }
  //   // await proceedWithPayment();
  // }

  const handleCodeModelShow = () => setShowPromoModal(true);
  const handleCodeModelClose = () => {
    setShowPromoModal(false);
    setPromoCode("");
    setValidated(false);
  };

  const redeemPromoCode = async (event) => {
    event.preventDefault();
    setValidated(true);
    if (!promoCode.trim()) return;
    try {
      const res = await RedeemPromoCode(promoCode.trim());
      if (res?.data?.status === true) {
        toast.success(res.data?.message);
        handleCodeModelClose();
        fetchSubscription();
      } else {
        toast.error(res.data?.message);
      }
    } catch (err) {
      toast.error("Failed to redeem promo code");
      console.error(err);
    }
  };

  const fetchSubscription = async () => {
    try {
      setIsLoading(true);
      const response = await GetSubScription();
      const list = response?.data?.data || [];
      setMessageSubscribe(response?.data?.message)
      if (list.length) {
        setDataSubscription(list[list.length - 1]);
      } else {
        setDataSubscription(null);
      }
    } catch (e) {
      console.error(e);
      setDataSubscription(null);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, []);

  const GetByIdPayment = async (data) => {
    try {
      const response = await PaymentGetById(data); // Call your API function

      setDataItem(response?.data?.data?.dataList || []);
      setUserData(response);
      setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    GetByIdPayment(data);
  }, [currentPage]);

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: true,
    };
    GetByIdPayment(data);
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const isRole = localStorage.getItem("role");

  const isSubscriptionActive = () => {
    if (!dataSubscription || !dataSubscription.subscriptionEndDate) {
      return false;
    }
    const currentDateTime = dayjs();
    const subscriptionEndDate = dayjs(
      dataSubscription.subscriptionEndDate + "Z"
    );
    return subscriptionEndDate.isAfter(currentDateTime);
  };

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <ToastContainer position="top-right" />
      <Modal show={showPromoModal} centered>
        <Form noValidate validated={validated} onSubmit={redeemPromoCode}>
          <Modal.Header className="promo-code-header promo-close" closeButton>
            <Modal.Title>
              <b>Redeem Promo Code</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="promoCodeInput">
              <InputGroup hasValidation>
                <Form.Control
                  required
                  type="text"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  placeholder="Enter your promo code"
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a valid promo code.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCodeModelClose}>
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              Redeem Now
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showConfirmModal} centered>
        <Modal.Header className="promo-code-header promo-close" closeButton>
          <Modal.Title>
            <b>Confirm New Payment</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>
              You already have an active subscription valid till:{" "}
              <h5>
                {dataSubscription?.subscriptionEndDate
                  ? dayjs(dataSubscription.subscriptionEndDate + "Z").format(
                      "MM/DD/YYYY hh:mm:ss A"
                    )
                  : "-"}
              </h5>
            </strong>
          </p>
          <p>
            <strong>Do you still want to proceed with a new payment?</strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={proceedWithPayment}>
            Yes, Proceed
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <h1 className="heading-dash">Account Settings</h1>
          <div className="group_data_table">
            <div className="subscription d-flex flex-wrap gap-4">
              <div className="subscription_box" style={{ flex: 1 }}>
                <div className="subscription_box-inner">
                  <h4>Subscription Details</h4>
                  {isLoading ? (
                    " "
                  ) : isSubscriptionActive() ? (
                    <Button variant="success">Active</Button>
                  ) : (
                    <button className="bg-danger">Inactive</button>
                  )}
                </div>

                {isLoading ? (
                  <div className="text-center py-4">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <>
                    <div className="subscription_box-inner pb-2 pt-2"></div>
                    <div className="subscription_box-inner">
                      <p>Amount:</p>
                      <p className="fw-bold">{dataSubscription?.amount || 0}</p>
                    </div>
                    <div className="subscription_box-inner">
                      <p>Auto Renew</p>
                      <p className="fw-bold">
                        {dataSubscription?.isAutoRenew ? "Yes" : "No"}
                      </p>
                    </div>
                    <div className="subscription_box-inner">
                      <p>Subscription Type</p>
                      <p className="fw-bold">
                        {dataSubscription?.subscriptionType || "-"}
                      </p>
                    </div>
                    <div className="subscription_box-inner">
                      <p>Subscription Start Date & Time</p>
                      <p className="fw-bold text-nowrap">
                        {dataSubscription?.subscriptionStartDate
                          ? dayjs(
                              dataSubscription.subscriptionStartDate + "Z"
                            ).format("MM/DD/YYYY hh:mm:ss A")
                          : "-"}
                      </p>
                    </div>
                    <div className="subscription_box-inner">
                      <p>Subscription End Date & Time</p>
                      <p className="fw-bold text-nowrap">
                        {dataSubscription?.subscriptionEndDate
                          ? dayjs(
                              dataSubscription.subscriptionEndDate + "Z"
                            ).format("MM/DD/YYYY hh:mm:ss A")
                          : "-"}
                      </p>
                    </div>
                    <div className="subscription_box-inner">
                      <p>Remaining Days:</p>
                      <p className="fw-bold">
                        {dataSubscription?.subscriptionRemainingDays || 0}
                      </p>
                    </div>
                  </>
                )}
              </div>

              <div
                className="subscription_box plan-select-form d-flex flex-column align-items-center"
                style={{ flex: 1 }}
              >
                <h3>Choose your subscription plan</h3>
                <Form className="w-100 text-center d-flex flex-column align-items-center gap-2">
                  <Form.Check
                    type="radio"
                    id="plan-monthly"
                    name="plan"
                    label={<h5>$ 4.99 Monthly </h5>}
                    value="1"
                    checked={selectedOption === "1"}
                    onChange={handleOptionChange}
                  />
                  <span>OR</span>
                  <Form.Check
                    type="radio"
                    id="plan-yearly"
                    name="plan"
                    label={<h5>$ 49 Yearly</h5>}
                    value="2"
                    checked={selectedOption === "2"}
                    onChange={handleOptionChange}
                  />
                </Form>
                <Row className="mt-4 justify-content-center gap-2">
                {/* {messageSubscribe === 'Subscription details record not found' ? "" :
                <Col xs="auto">
                    <Button
                      disabled={!selectedOption}
                      onClick={handleOneTab}
                    >
                    <icons.HandIndex className="icons" style={{fontSize:'23px'}} />&nbsp;
                      OneTab Payment
                    </Button>
                  </Col>
                  } */}
                  <Col xs="auto">
                    <Button
                      disabled={!selectedOption}
                      onClick={handleSubmitPlayer}
                    >
                      Make Payment
                    </Button>
                  </Col>
                  <Col xs="auto">
                    <Button
                      onClick={handleCodeModelShow}
                      variant="outline-primary"
                    >
                      Promo Code
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="table-transaction mb-4">
              <h1 className="subscription_heading">Transaction History</h1>
              <div className="table-responsive">
                <Table bordered hover className="table-team border">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Status</th>
                      <th>Amount</th>
                      <th>Plan Type</th>
                      <th>Transaction ID</th>
                      <th>Transaction Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dataItem.length > 0 ? (
                      dataItem.map((item) => (
                        <tr key={item.paymentId || item.id}>
                          <td>{item.name}</td>
                          <td>
                            {item.paymentStatus === "paid" ? (
                              <span className="text-success">Paid</span>
                            ) : (
                              <span className="text-danger">Unpaid</span>
                            )}
                          </td>
                          <td>{item.amount}</td>
                          <td>{item.planType}</td>
                          <td>{item.paymentId}</td>
                          <td>
                            {item.paymentDate
                              ? dayjs(item.paymentDate + "Z").format(
                                  "MM/DD/YYYY hh:mm:ss A"
                                )
                              : "-"}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center">
                          No transactions found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
              {totalRows > 1 && (
                <Row>
                  <Col md={12} className="text-right">
                    <div className="pagination-controls">
                      <label>Rows per page: </label>
                      <select
                        id="itemsPerPage"
                        value={perPage}
                        onChange={handlePerPageChange}
                      >
                        {pageOptions.map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>

                      <Button
                        onClick={handlePreviousPage}
                        disabled={currentPage === 1}
                      >
                        <icons.ArrowLeft></icons.ArrowLeft>
                      </Button>
                      <span>
                        {currentPage} of {totalRows}{" "}
                      </span>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage >= Math.ceil(totalRows)}
                      >
                        <icons.ArrowRight></icons.ArrowRight>
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          </div>
        </div>
        <div className={data ? "Footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
